/** @format */

import { CardMedia, styled } from "@mui/material";
import { colors } from "../../utility/types/constant";

export const ParentContainer = styled("div")(({ theme }) => ({
	display: "flex",
	width: "100%",
	flexDirection: "row",
	gap: "40px",
	alignItems: "stretch",
	justifyContent: "center",
	marginBottom: "100px",
	marginTop: "60px",
	padding: "0 20px",
	maxWidth: "1400px",
	margin: "60px auto 100px auto",

	[theme.breakpoints.down("xs")]: {
		flexDirection: "column",
		gap: "30px",
	},

	[theme.breakpoints.down("sm")]: {
		flexDirection: "column",
		gap: "30px",
	},

	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		gap: "30px",
	},
}));

export const ChildContainerOne = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	width: "100%",
}));

export const ChildContainerTwo = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	width: "100%",
}));

export const TypographyWrapper = styled("div")({
	padding: "19px",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
});

export const StyledTypographyHeader = styled("div")(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(1.125rem, 2vw, 1.375rem)",
	fontWeight: 600,
	color: "#6c757d",
	textAlign: "center",
	marginBottom: "8px",
}));

export const StyledTypographySubHeader = styled("div")(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(1.75rem, 3vw, 2.5rem)",
	fontWeight: 800,
	color: colors.primary,
	marginBottom: "20px",
	textAlign: "center",
	lineHeight: 1.2,
}));

export const StyledTypography = styled("div")(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(0.9375rem, 1.5vw, 1.0625rem)",
	fontWeight: 400,
	textAlign: "center",
	color: "#4a5568",
	lineHeight: 1.8,
}));

// Modern Card for Benefits
export const ModernBenefitCard = styled("div")(({ theme }) => ({
	backgroundColor: "#ffffff",
	borderRadius: "20px",
	padding: "40px",
	boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
	transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
	border: "1px solid rgba(0,0,0,0.06)",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	height: "100%",
	position: "relative",
	overflow: "hidden",
	"&::before": {
		content: '""',
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		height: "4px",
		background: colors.mainSecondary,
		transform: "scaleX(0)",
		transition: "transform 0.4s ease",
	},
	"&:hover": {
		transform: "translateY(-10px)",
		boxShadow: "0 20px 40px rgba(30, 193, 149, 0.2)",
		"&::before": {
			transform: "scaleX(1)",
		},
	},
	[theme.breakpoints.down("md")]: {
		padding: "30px",
	},
}));

export const IconCircle = styled("div")(({ theme }) => ({
	width: "100px",
	height: "100px",
	borderRadius: "50%",
	background: colors.mainSecondary,
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	marginBottom: "25px",
	color: "#ffffff",
	boxShadow: "0 8px 20px rgba(30, 193, 149, 0.3)",
	transition: "all 0.3s ease",
	"& svg": {
		fontSize: "48px",
	},
}));

export const ImageContainer = styled("div")(({ theme }) => ({
	display: "flex",
	width: "100%",
	alignItems: "center",
	// height: '100%',
	justifyContent: "center",

	[theme.breakpoints.down("sm")]: {
		// Adjustments for small screens
		width: "100%",
		height: "100%",
	},
}));

type StyledCardMediaProps = React.ComponentProps<typeof CardMedia> & {
	component?: string;
	alt?: string;
};

export const StyledCardMedia = styled(CardMedia)<StyledCardMediaProps>(
	({ theme }) => ({
		maxWidth: "60%", // Full width of the parent container
		height: "60svh", // Height is auto to maintain aspect ratio
		objectFit: "cover", // Cover the whole area without stretching
		borderRadius: "20px",

		[theme.breakpoints.down("sm")]: {
			height: "50svh",
			borderRadius: "20px",
			width: "100%", // Ensuring full width on small screens
		},
	})
);

export const BaseImage = styled(CardMedia)(({ theme }) => ({
	// position: 'absolute',
	zIndex: 1,
	width: "100%", // Full width of the parent container
	height: "auto", // Keep aspect ratio
	top: 0,

	justifyContent: "center",
	display: "flex",
	alignContent: "center",
	alignItems: "center",
}));
